import React, { ReactElement, useContext, useState } from 'react'
import { ArtData } from '@/database/art'
import Button from '@/components/Button'
import { Context } from '@/components/Context'

const Vote = ({ artData }: { artData: ArtData }): ReactElement => {
    const { votePower, accountSignature, voteHandler } = useContext(Context)

    const [voteValue, setVoteValue] = useState('')

    const handleVoteInputChange = (event: { target: { value: string } }) => {
        const input = event.target.value.replace(',', '.') // Normalize input

        // Check if the last character is a dot or if the input is just a dot
        const endsWithDot = input.endsWith('.') || input === '.'

        // Use a regular expression to validate if the input is in a correct numeric format (including dots)
        const isValidNumericInput = /^(\d+\.?\d*|\.\d+)$/.test(input)

        if (endsWithDot || isValidNumericInput) {
            // Directly update the state with the input if it's a valid numeric input or ends with a dot
            const newInput = parseFloat(input)
            if (newInput > parseFloat(votePower)) {
                setVoteValue(voteValue.toString())
            } else {
                setVoteValue(input)
            }
        } else if (input === '') {
            setVoteValue('')
        } else {
            setVoteValue(`0`)
        }
    }

    return (
        <div className="input-container artwork-box">
            <div className={'header-container'}>
                <div className="nav__balance menu-wrapper-column border margin-box">
                    <div className="nav__voted-amount">{votePower}</div>
                    <span className="gray bold small">Vote Power</span>
                </div>
            </div>
            <input
                type="range"
                min="0"
                max={parseFloat(votePower) || 0}
                step="0.01"
                value={parseFloat(voteValue) || 0}
                onChange={(event) => setVoteValue(parseFloat(event.target.value).toFixed(2))}
            />
            <input
                type="text"
                min="0"
                max={parseFloat(votePower) || 0}
                value={voteValue}
                onChange={handleVoteInputChange}
            />
            <Button
                btnName={`Vote`}
                classStyles="nav__medium"
                disabled={!accountSignature || !Number(voteValue)}
                handleClick={() =>
                    accountSignature
                        ? voteHandler(artData, parseFloat(voteValue))
                        : alert('Please connect your wallet to proceed transaction')
                }
                cancelBg={undefined}
            />
        </div>
    )
}

export default Vote
